/* global axios */
import ApiClient from './ApiClient';

class InternalCallsAPI extends ApiClient {
  constructor() {
    super('internal_chats', { accountScoped: true });
  }

  // Call lifecycle is nested under a chat: internal_chats/:chatId/calls
  initiate(chatId, { callType = 'audio' } = {}) {
    return axios.post(`${this.url}/${chatId}/calls`, { call_type: callType });
  }

  show(chatId, callId) {
    return axios.get(`${this.url}/${chatId}/calls/${callId}`);
  }

  answer(chatId, callId) {
    return axios.post(`${this.url}/${chatId}/calls/${callId}/answer`);
  }

  decline(chatId, callId) {
    return axios.post(`${this.url}/${chatId}/calls/${callId}/decline`);
  }

  end(chatId, callId) {
    return axios.post(`${this.url}/${chatId}/calls/${callId}/end`);
  }
}

export default new InternalCallsAPI();
